import './TopBarWidget.scss';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { useContext } from 'react';
import { WeatherDashboardContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/WeatherDashboardContextProvider';
import { TimePeriodSelector } from 'app/agriculture/routes/WeatherModal/components/TimePeriodSelector';
import { WeatherStationSelector } from 'app/agriculture/routes/WeatherModal/components/WeatherStationSelector';
import { CurrentWeatherStatus } from 'app/agriculture/routes/WeatherModal/components/CurrentWeatherStatus';
import { TopbarWidgetSkeleton } from './TopbarWiddgetSkeleton/TopbarWidgetSkeleton';

export function TopBarWidget() {
    const { weatherStationId, setWeatherStationId, viewMode, setViewMode } =
        useContext(WeatherDashboardContext);

    return (
        <div className={'TopBarWidget'}>
            <SuspenseWrapper loadingComponent={<TopbarWidgetSkeleton />}>
                <div className={'TopBarWidget__selectors'}>
                    <WeatherStationSelector
                        initialWeatherStationId={weatherStationId}
                        onChange={(weatherStationId) => {
                            if (weatherStationId == null) return;
                            setWeatherStationId(weatherStationId);
                        }}
                    />
                    <TimePeriodSelector chartViewMode={viewMode} setChartViewMode={setViewMode} />
                </div>
                <div className="WeatherCurrentStats">
                    <div className="WeatherCurrentStats__label">Current</div>
                    <CurrentWeatherStatus />
                </div>
            </SuspenseWrapper>
        </div>
    );
}
